<template>
    <div name="file-view" class="wrapper">
        <div class="page">
            <div class="button-header">
                <img @click="back" style="width: 26px; cursor: pointer;" src="../../../assets/medical_back_icon.png" />
            </div>
            <div style="width: 100%;">
               <two-select-box 
                    :options1="select1List"
                    :options2="select2List"
                    :options3="select3List"
                    :selectedIndex="selected1"
                    @select="selectFile"
               />
            </div>
            <!-- 최종 높이 계산하여 스크롤 반영 -->
   
            <iframe v-if="selectedType === 'receipt/url'" :src="selectedUrl" width="100%" height="600px" style="margin-top: 16px;"></iframe>
            <img v-else-if="selectedType === 'image/png' || selectedType === 'image/jpeg'" style="width: 100%; " :src="selectedUrl" />
            <pdf v-else-if="selectedType === 'application/pdf'" :src="selectedUrl" style="width: 100%;" :page="1"></pdf>
            <receipt v-else-if="selectedType === 'receipt/data' " :receipt="receipt" />
            <div class="no-document" v-else>
                <img style="width: 80px;" src="../../../assets/warning.png" />
                <span class="no-document-text1">미리보기가 지원되지 않는<br>
                    파일 형식입니다.</span>
                <span class="no-document-text2">아래 버튼을 클릭하여 다운로드 받아주세요.</span>
            </div>
            <!-- <pdf v-if="selectedType === 'application/pdf'" :src="selectedUrl" style="width: 100%; min-height: 80vh;" :page="2"></pdf> -->
       

            <div class="bottom-fixed-info" v-if="selectedType === 'receipt/url'">
                <span>다운로드는</span><br><span style="color: #184FA1;">PC에서 🖨️ 버튼 → [PDF 저장]</span>을 이용해주세요.</div>
            <div class="bottom-button-box" v-if="selectedType !== 'receipt/url'">
                <bottom-button
                    :text="'이 서류 저장하기'"
                    :color="'var(--Gray-100, #1E1E1E)'"
                    @onClick="downloadDoc2"
                />
            </div>
        </div>
    </div>
</template>

<script>
import Constant from '@/constant';
import {mapState} from 'vuex';
import cookies from '@/utilities/cookie.js';
import TwoSelectBox from '@/components/atoms/TwoSelectBox';
import Receipt from '@/components/molecules/Receipt.vue';
import pdf from "vue-pdf";
import BottomButton from '@/components/atoms/BottomButton';
import html2canvas from 'html2canvas'
import axios from 'axios';

export default {
    name: 'fileView',
    data: function()
    {
        return {
            documents: null,
            selected1: this.selectedCategory,
            selected2: 0,
            selectedUrl: null,
            selectedType: null,
            receipt: null,
            name: '서류'
        }
    },
    components: {
        TwoSelectBox,
        pdf,
        Receipt,
        BottomButton
    },
    computed: mapState(['diabetes_documents']),
    props: ['history', 'selectedCategory', 'select1List', 'select2List', 'select3List'],  // 0: 처방전, 1: 구매내역
    mounted: function()
    {
        // document.body.style.overflow = 'hidden'; // 스크롤 비활성화
        // history에 reception number를 통하여 api 호출 
        // documents
        this.selected1 = this.selectedCategory;
        if(this.selectedCategory === 0)
        {
            if(this.diabetes_documents.prescriptions.length > 0)
            {
                this.selectedUrl = this.diabetes_documents.prescriptions[0].url;
                this.selectedType = this.diabetes_documents.prescriptions[0].type;
                this.name = this.diabetes_documents.prescriptions[0].name;
                if(this.selectedType === 'receipt/data')
                {
                    this.receipt = this.diabetes_documents.prescriptions[0].receipt;
                }
            }
            else
            {
                this.selectedUrl = this.diabetes_documents.purchase_docs[0].url
                this.selectedType = this.diabetes_documents.purchase_docs[0].type;
                this.name = this.diabetes_documents.purchase_docs[0].name;
                if(this.selectedType === 'receipt/data')
                {
                    this.receipt = this.diabetes_documents.purchase_docs[0].receipt;
                }
            }
        }
        else 
        {
            this.selectedUrl = this.diabetes_documents.purchase_docs[0].url
            this.selectedType = this.diabetes_documents.purchase_docs[0].type;

            this.name = this.diabetes_documents.purchase_docs[0].name;
            if(this.selectedType === 'receipt/data')
            {
                this.receipt = this.diabetes_documents.purchase_docs[0].receipt;
            }
        }
    
 
    },
    methods: {
        dataURLToBlob:function (dataURL) {
            const binaryString = atob(dataURL.split(",")[1]);
            const array = [];
            for (let i = 0; i < binaryString.length; i++) {
                array.push(binaryString.charCodeAt(i));
            }
            return new Blob([new Uint8Array(array)], { type: "image/png" });
        },
        htmltoimage: function()
        {
            let _this = this;
            html2canvas(document.getElementById('receipt')).then(canvas => {
                _this.onSaveAs(canvas.toDataURL('image/png'), `contract.png`)      

            })
        },
        onSaveAs: async function(uri) {
            // 솔닥 앱(nachocode) 웹뷰에서는 a.click() 다운로드가 먹통되는 이슈가 있어
            // Web Share API(네이티브 공유 시트 → 저장)로 처리
            if (navigator.userAgent.toLowerCase().includes('nachocode')) {
                try {
                    const blob = this.dataURLToBlob(uri);
                    const file = new File([blob], `${this.history.time}_${this.name}.png`, { type: 'image/png' });
                    if (navigator.share && navigator.canShare && navigator.canShare({ files: [file] })) {
                        await navigator.share({ files: [file], title: `${this.history.time}_${this.name}` });
                    } else {
                        window.location.href = uri;
                    }
                } catch (err) {
                    if (!err || err.name !== 'AbortError') {
                        window.location.href = uri;
                    }
                }
                return;
            }

            var link = document.createElement('a');
            document.body.appendChild(link);
            link.href = uri;
            link.download= `${this.history.time}_${this.name}`;
            link.click();
            document.body.removeChild(link);
        },
        downloadDoc2: async function()
        {
            if(this.selectedType === 'receipt/data')
            {
                this.htmltoimage()
                return;
            }
            if(this.selectedType === 'receipt/url')
            {
                return;
            }

            let ext = '';
            if(this.selectedType === 'image/png') ext = '.png';
            else if(this.selectedType === 'image/jpeg') ext = '.jpg';
            else if(this.selectedType === 'application/pdf') ext = '.pdf';
            // const fileName = `${this.history.time}_${this.name}${ext}`;
            const fileName = `${this.name}${ext}`;

            // 솔닥 앱(nachocode) 웹뷰에서는 a.click() 다운로드가 먹통되는 이슈가 있어
            // Web Share API(네이티브 공유 시트 → 저장)로 처리
            if (navigator.userAgent.toLowerCase().includes('nachocode')) {
                try {
                    const resp = await fetch(this.selectedUrl);
                    const blob = await resp.blob();
                    const file = new File([blob], fileName, { type: blob.type || this.selectedType });
                    if (navigator.share && navigator.canShare && navigator.canShare({ files: [file] })) {
                        await navigator.share({ files: [file], title: fileName });
                    } else {
                        window.location.href = this.selectedUrl;
                    }
                } catch (err) {
                    // 사용자가 공유 시트를 취소한 경우(AbortError)는 무시
                    if (!err || err.name !== 'AbortError') {
                        window.location.href = this.selectedUrl;
                    }
                }
                return;
            }

            // 카카오톡 인앱 브라우저(안드로이드/iOS)는 blob: URL 다운로드를 지원하지 않아("지원하지 않는 파일 형식입니다")
            // 서버 GET 다운로드 URL(Content-Disposition: attachment)로 직접 이동
            if (navigator.userAgent.includes('KAKAOTALK')) {
                window.location.href = `${process.env.API_DB_ROOT}/download/uploadfiles?fileUrl=${encodeURIComponent(encodeURI(this.selectedUrl))}&fileName=${encodeURIComponent(fileName)}`;
                return;
            }

            let blob;
            let filename = fileName;
            try {
                const res = await axios.post(
                    `${process.env.API_DB_ROOT}/download/uploadfiles`,
                    { fileUrl: encodeURI(this.selectedUrl), fileName },
                    { responseType: 'blob' }
                );
                const disposition = res.headers['content-disposition'] || '';
                const match = disposition.match(/filename="?([^"]+)"?/);
                if (match) filename = decodeURIComponent(match[1]);
                blob = res.data;
            } catch (e) {
                // 다운로드 서버 실패 시 CDN(CloudFront, CORS 허용)에서 직접 받아 저장
                try {
                    const resp = await fetch(this.selectedUrl);
                    if (!resp.ok) throw new Error(`HTTP ${resp.status}`);
                    blob = await resp.blob();
                } catch (err) {
                    alert('다운로드에 실패했습니다. 잠시 후 다시 시도해주세요.');
                    return;
                }
            }

            const blobUrl = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = blobUrl;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(blobUrl);
        },
        downloadDoc: function()
        {
            if (navigator.userAgent.includes('NAVER')) {

                alert('네이버 앱을 통해 접속 시 문서 다운로드가 원활하지 않을 수 있습니다. \n다운로드가 되지 않을 경우, 크롬이나 삼성인터넷 등 다른 브라우저를 이용 부탁드립니다.');

                if (navigator.userAgent.includes('Android')) {
                    if(this.selectedType === 'image/png' || this.selectedType === 'image/jpeg')
                    {
                        this.onSaveAs(this.selectedUrl)
                    }
                    else if(this.selectedType === 'application/pdf')
                    {
                        this.onSaveAs(this.selectedUrl)
                    }
                    else if(this.selectedType === 'receipt/data')
                    {
                        this.htmltoimage()
                    }
                    else if(this.selectedType === 'receipt/url')
                    {

                    }
                    else 
                    {
                        this.onSaveAs(this.selectedUrl)
                    }

                    return;
                } 

            let file_name = "file";
            if(this.selectedType === 'image/png')
            {
               file_name = `${this.history.time}_${this.name}.png`
            }
            else if(this.selectedType === 'image/jpeg')
            {
                file_name = `${this.history.time}_${this.name}.jpg`
            }
            else if(this.selectedType === 'application/pdf')
            {
                file_name = `${this.history.time}_${this.name}.pdf`
            }
            else if(this.selectedType === 'receipt/data')
            {
                this.htmltoimage()
                return;
            }
            

                fetch(this.selectedUrl)
                .then(res => res.blob())
                .then(blob => {
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = file_name;
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                    window.URL.revokeObjectURL(url);
                });
                return;
            }

            if(this.selectedType === 'image/png' || this.selectedType === 'image/jpeg')
            {
                this.onSaveAs(this.selectedUrl)
            }
            else if(this.selectedType === 'application/pdf')
            {
                this.onSaveAs(this.selectedUrl)
            }
            else if(this.selectedType === 'receipt/data')
            {
                this.htmltoimage()
            }
            else if(this.selectedType === 'receipt/url')
            {

            }
            else 
            {
                this.onSaveAs(this.selectedUrl)
            }
        },
        back: function()
        {
            // document.body.style.overflow = ''; // 스크롤 활성화
            this.$emit('onClose')
        },
        selectFile: function(index1, index2, index3)
        {
            if(index1 === 0)
            {
                if(this.diabetes_documents.prescriptions.length > 0)
                {
                    this.selectedUrl = this.diabetes_documents.prescriptions[index2].url
                    this.selectedType = this.diabetes_documents.prescriptions[index2].type;
                    this.name = this.diabetes_documents.prescriptions[index2].name;
                    if(this.selectedType === 'receipt/data')
                    {
                        this.receipt = this.diabetes_documents.prescriptions[index2].receipt;
                    }
                }
                else
                {
                    this.selectedUrl = this.diabetes_documents.purchase_docs[index2].url
                    this.selectedType = this.diabetes_documents.purchase_docs[index2].type;
                    this.name = this.diabetes_documents.purchase_docs[index2].name;
                    if(this.selectedType === 'receipt/data')
                    {
                        this.receipt = this.diabetes_documents.purchase_docs[index2].receipt;
                    }
                }
            }
            else 
            {
                this.selectedUrl = this.diabetes_documents.purchase_docs[index3].url
                this.selectedType = this.diabetes_documents.purchase_docs[index3].type;
                this.name = this.diabetes_documents.purchase_docs[index3].name;
                if(this.selectedType === 'receipt/data')
                {
                    this.receipt = this.diabetes_documents.purchase_docs[index3].receipt;
                }
            }
        }
    }
}
</script>

<style scoped>
    .wrapper {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;

    }
    .page {
        width: 100%;
        background: #FFF;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        box-sizing: border-box;
        padding: 0 16px;
        overflow: hidden;
        padding-bottom: 100px;
    }

    @media (min-width: 600px) {
        .page {
            width: 600px;
        }
    }
    .document-list {
        width: 100%;
    }
    .button-header {
        width: 100%;
        height: 49px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        box-sizing: border-box;
    }
    .bottom-button-box {
        width: calc(100% - 32px);
        position: fixed;
        bottom: 28px;
        max-width: 568px;
    }
    .no-document {
        height: 379px;
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        padding: 86px 16px 0 16px;
    }
    .no-document-text1 {
        color: var(--Gray-50, #A3AAB6);
        text-align: center;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
        line-height: 20px; /* 111.111% */
        margin-top: 50px;
    }
    .no-document-text2 {
        color: var(--Gray-50, #A3AAB6);
        text-align: center;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px; /* 111.111% */
        margin-top: 20px;
    }
    .bottom-fixed-info {
        border-top: 1px solid var(--gray-40-button-stroke, #D1D6DB);
        background: linear-gradient(0deg, #F3F5F8 0%, rgba(243, 245, 248, 0.00) 255.33%);
        width: calc(100% - 32px);
        position: fixed;
        bottom: 0;
        max-width: 568px;
        height: 88px;
        color: var(--Gray-60, #6B7684);
        text-align: center;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 500;
        line-height: 20px; /* 111.111% */
        box-sizing: border-box;
        padding-top: 16px;
    }
</style>


// WEBPACK FOOTER //
// src/components/organisms/contract/FileView.vue